module.exports = __webpack_public_path__ + "media/application/assets/images/play-d9385c10f7a9562b7e26e859b1108b30.png";